import classnames from 'classnames'
import Link from 'next/link'
import React, { PropsWithChildren } from 'react'
import DarkBannerPlaceholder from '../../../public/images/blog_detail_dark_bg.svg'
import { PageBannerComponent } from '../../components/PageBanners/PageBannerComponent'
import { withSlice } from '../SliceComponent'
import classes from './BlogHeaderWithBanner.module.scss'
import { Props as BlogHeaderProps } from './data'

export const BlogHeaderWithBanner: React.FC<PropsWithChildren<BlogHeaderProps>> = ({ children, slice }) => {
  const pageBannerData = slice
  const dateCreated = new Date(pageBannerData?.first_published_at)

  return (
    <div className={classnames(classes.pageBannerContainer, classes.active)}>
      <div className={classes.headerMenuWrapper}>
        {children}
      </div>
      <PageBannerComponent bannerType="side_banner" src={pageBannerData?.content?.post_featuredImage?.filename ? pageBannerData?.content?.post_featuredImage?.filename : DarkBannerPlaceholder}>
        <div className={classes.blogHeaderContainer}>
          <div className={classes.blogHeaderWrapper}>
            <h1 className={classes.bannerTitle}>{pageBannerData.name}</h1>
            <div className={classes.createdDate}>
              <span className={classes.date}>
                {new Intl.DateTimeFormat('en-AU', { month: 'short' }).format(dateCreated)} {new Intl.DateTimeFormat('en-AU', { day: '2-digit' }).format(dateCreated)}, {new Intl.DateTimeFormat('en-AU', { year: 'numeric' }).format(dateCreated)}
              </span>
              <span className={classes.separator}>|</span>
              <span className={classes.author}>By {pageBannerData?.content?.post_team_author?.story?.content?.name ? (<Link passHref href={`/team?member=${pageBannerData?.content?.post_team_author?.story?.slug}`}><a className={classes.authorLink} href="#">{pageBannerData?.content?.post_team_author?.story?.name}</a></Link>) : <Link passHref href={'/team'}><a className={classes.authorLink} href="#">atomix</a></Link>}</span>
            </div>
            {pageBannerData?.content?.post_readTime && (
              <div className={classes.readTime}>Read time: {pageBannerData?.content?.post_readTime} mins</div>
            )}
          </div>
        </div>
      </PageBannerComponent>
    </div>
  )
}

export default withSlice(BlogHeaderWithBanner)
